import React, { useState } from 'react';

import { MainSurface, ScreenLayout } from '@appComponents/ScreenLayout';
import TripsTable from '../../components/TripsTable';
import { useQuery } from './Trips';
import { useAircraftList } from '@appUtils/aircraft';
import { useUnreadCompanyMessages } from '@appUtils/messages';

const ArchivedTripsScreen = () => {
  const [sort, setSort] = useState(INITIAL_SORT);
  const { data, loading, error } = useQuery({
    activeTab: 'All',
    sort,
    archived: true,
  });
  const { data: aircraft } = useAircraftList();
  const { data: unreadMessages } = useUnreadCompanyMessages(true);

  return (
    <ScreenLayout alignItems="stretch">
      <MainSurface>
        <TripsTable
          statusCol
          bulkActions
          highlightRequests
          data={data}
          loading={loading}
          error={error}
          initialSort={sort}
          onSortChange={setSort}
          aircraft={aircraft}
          unreadMessages={unreadMessages}
        />
      </MainSurface>
    </ScreenLayout>
  );
};

const INITIAL_SORT = { dir: 'desc', title: 'Departure' };

export default ArchivedTripsScreen;
